import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, watch, computed } from "vue";
  import { HouseInclusionsPack } from "@/types/HouseInclusionPack";
  import BuilderEstimatorStepTitle from "@/components/builder/estimator-tool/BuilderEstimatorStepTitle.vue";
  import InclusionPackCard from "./InclusionPackCard.vue";
  import { sortByPriceAscending } from "@/helpers/sortByPriceAscending";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorInclusionsPack',
  props: {
    inclusionPackages: {},
    selectedInclusionPack: {}
  },
  emits: ["onSelectInclusionPack"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const selectedPackage = ref<HouseInclusionsPack | null>(null);
  const expandedSections = reactive<Record<string, boolean>>({});

  const { isDesktop } = useIsDesktop(990);
  const inclusionTypes = computed(() =>
    props.inclusionPackages.map((pack) => pack.inclusionId.type)
  );
  const selectedType = ref<string>(inclusionTypes.value[0]);

  const packages = computed(() => {
    const filteredPackages = !isDesktop.value
      ? props.inclusionPackages.filter(
          (pack) =>
            pack.inclusionId.type.toLowerCase() ===
            selectedType.value.toLowerCase()
        )
      : props.inclusionPackages;

    return sortByPriceAscending(filteredPackages);
  });

  const onSelectInclusionPack = (pack: HouseInclusionsPack) => {
    selectedPackage.value =
      selectedPackage.value?.inclusionId.type === pack.inclusionId.type
        ? null
        : pack;
    emits("onSelectInclusionPack", selectedPackage.value ? pack : null);
  };

  const toggleSection = (sectionKey: string) => {
    expandedSections[sectionKey] = !expandedSections[sectionKey];
  };

  const setInclusionType = (type: string) => {
    selectedType.value = type;

    if (!isDesktop.value) {
      const pack = props.inclusionPackages.find(
        (p) => p.inclusionId.type.toLowerCase() === type.toLowerCase()
      );

      if (pack) {
        onSelectInclusionPack(pack);
      }
    }
  };

  watch(
    () => packages.value,
    (newPackages) => {
      newPackages.forEach((pack) => {
        pack.inclusionId.inclusions.forEach((inclusion) => {
          expandedSections[inclusion.name] = false;
        });
      });

      if (newPackages.length > 0 && !selectedPackage.value) {
        onSelectInclusionPack(newPackages[0]);
      }
    },
    { immediate: true }
  );

  watch(
    () => props.selectedInclusionPack,
    (newVal) => {
      selectedPackage.value = newVal;
    },
    { immediate: true }
  );

const __returned__ = { props, emits, selectedPackage, expandedSections, isDesktop, inclusionTypes, selectedType, packages, onSelectInclusionPack, toggleSection, setInclusionType, ref, reactive, watch, computed, get HouseInclusionsPack() { return HouseInclusionsPack }, BuilderEstimatorStepTitle, InclusionPackCard, get sortByPriceAscending() { return sortByPriceAscending }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})